import React, { useEffect, useState } from "react";
import GrayCard from "components/gray-card";
import Dropdown, { IDropItem } from "components/inputs/dropdown";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import Modal from "components/modal";

import { ITrackArtists } from "types/musicData";
import TextInput from "components/inputs/text-input";
import AddArtistModal from "components/modal/modals/addArtist";
import { GetUserArtists } from "services/user/getUser";

interface IProps {
  setTrackArtists: (object: ITrackArtists[]) => void;
  data?: ITrackArtists[];
}
const TrackArtists = ({ setTrackArtists, data }: IProps) => {
  const [artistModal, setArtistModal] = useState(false);

  const Artists = () => {
    let temp = GetUserArtists();
    let data: (string | IDropItem)[] = ["None"];
    for (let i = 0; i < temp.length; i++) {
      data.push({
        label: temp[i].name,
        icon: (
          <ArtistIcon>
            <Typography size="s" color={Colors.white200}>
              {temp[i].name[0]}
            </Typography>
          </ArtistIcon>
        )
      });
    }
    return data;
  };

  const [artists, setArtists] = useState<ITrackArtists[]>(
    data || [{ type: "Primary Artist", name: "" }]
  );

  const updateArtistName = (index: number, newName: string) => {
    setArtists((prevArtists) =>
      prevArtists.map((artist, i) =>
        i === index ? { ...artist, name: newName } : artist
      )
    );
  };

  const handleAddArtist = (type: string, name: string) => {
    setArtists([...artists, { type, name }]);
  };

  const RemoveArtist = (indexToRemove: number) => {
    setArtists((prevArtists) =>
      prevArtists.filter((_, index) => index !== indexToRemove)
    );
  };

  useEffect(() => {
    setTrackArtists(artists);
  }, [artists]);
  return (
    <GrayCard title="Track Artists">
      <Typography weight="medium" mb="0.4">
        Primary Artist
      </Typography>
      <Dropdown
        items={Artists()}
        chosenItem={artists[0].name}
        selectItem={(value) => updateArtistName(0, value)}
      />
      {artists.map((artist, i) => {
        if (i === 0) {
          return null;
        }
        return (
          <ArtistItem key={i}>
            <DeleteContainer onClick={() => RemoveArtist(i)}>
              <TrashIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M11.9597 3.5H2.04297"
                    stroke="#FF3333"
                    stroke-width="0.875"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10.9879 4.9585L10.7195 8.98297C10.6163 10.5317 10.5647 11.306 10.0601 11.7781C9.55549 12.2502 8.77942 12.2502 7.22729 12.2502H6.7762C5.22404 12.2502 4.44797 12.2502 3.94338 11.7781C3.4388 11.306 3.38717 10.5317 3.28392 8.98297L3.01562 4.9585"
                    stroke="#FF3333"
                    stroke-width="0.875"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.54297 6.4165L5.83464 9.33317"
                    stroke="#FF3333"
                    stroke-width="0.875"
                    stroke-linecap="round"
                  />
                  <path
                    d="M8.45964 6.4165L8.16797 9.33317"
                    stroke="#FF3333"
                    stroke-width="0.875"
                    stroke-linecap="round"
                  />
                  <path
                    d="M3.79297 3.5C3.82557 3.5 3.84186 3.5 3.85664 3.49963C4.33698 3.48745 4.76073 3.18203 4.92418 2.73019C4.92921 2.71629 4.93436 2.70083 4.94467 2.6699L5.0013 2.5C5.04965 2.35496 5.07382 2.28244 5.10588 2.22087C5.23381 1.97521 5.47048 1.80462 5.74399 1.76095C5.81254 1.75 5.889 1.75 6.04189 1.75H7.96071C8.1136 1.75 8.19008 1.75 8.25862 1.76095C8.53214 1.80462 8.7688 1.97521 8.89673 2.22087C8.92881 2.28244 8.95296 2.35496 9.00132 2.5L9.05796 2.6699C9.06823 2.70079 9.07342 2.7163 9.07844 2.73019C9.24188 3.18203 9.66562 3.48745 10.146 3.49963C10.1608 3.5 10.177 3.5 10.2096 3.5"
                    stroke="#FF3333"
                    stroke-width="0.875"
                  />
                </svg>
              </TrashIcon>
              <Typography size="s" color={Colors.danger} ml="0.4">
                Remove Artist
              </Typography>
            </DeleteContainer>
            <TextInput
              key={i}
              value={artist.name}
              label={artist.type}
              disabled
              lockTip="default"
            />
          </ArtistItem>
        );
      })}
      <AddArtistContainer onClick={() => setArtistModal(true)}>
        <AddIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M7.0013 12.8332C10.223 12.8332 12.8346 10.2215 12.8346 6.99984C12.8346 3.77818 10.223 1.1665 7.0013 1.1665C3.77964 1.1665 1.16797 3.77818 1.16797 6.99984C1.16797 10.2215 3.77964 12.8332 7.0013 12.8332Z"
              stroke="#FEB73D"
              stroke-width="0.875"
            />
            <path
              d="M8.75 7H7M7 7H5.25M7 7V5.25M7 7V8.75"
              stroke="#FEB73D"
              stroke-width="0.875"
              stroke-linecap="round"
            />
          </svg>
        </AddIcon>
        <Typography color={Colors.yellow400} ml="0.8">
          Add Artist(s)
        </Typography>
      </AddArtistContainer>
      <InfoContainer>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6C1 3.23857 3.23857 1 6 1C8.7614 1 11 3.23857 11 6ZM6 8.875C6.2071 8.875 6.375 8.7071 6.375 8.5V5.5C6.375 5.2929 6.2071 5.125 6 5.125C5.7929 5.125 5.625 5.2929 5.625 5.5V8.5C5.625 8.7071 5.7929 8.875 6 8.875ZM6 3.5C6.27615 3.5 6.5 3.72386 6.5 4C6.5 4.27614 6.27615 4.5 6 4.5C5.72385 4.5 5.5 4.27614 5.5 4C5.5 3.72386 5.72385 3.5 6 3.5Z"
            fill="#909090"
          />
        </svg>
        <Typography size="s" color={Colors.grey500} ml="0.4">
          Your release can be listed under more than one artist, use the
          additional artist row to compose the fullrelease artist name
        </Typography>
      </InfoContainer>
      <Modal isActive={artistModal} closeModal={() => setArtistModal(false)}>
        <AddArtistModal
          close={() => setArtistModal(false)}
          confirm={(artist) => {
            handleAddArtist(artist.type, artist.name);
          }}
        />
      </Modal>
    </GrayCard>
  );
};

export default TrackArtists;

const ArtistIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.purple200};
`;

const ArtistItem = styled.div`
  margin-top: 2.4rem;
  position: relative;
`;
const DeleteContainer = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  z-index: 2;
`;
const TrashIcon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;
const InfoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const AddArtistContainer = styled.div`
  margin: 2.4rem 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const AddIcon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;
